import React from 'react';
import ProjectLayout from '../Components/ProjectLayout';

import normalImg from '../assets/projects/contrast/contrast-normal-img.webp';
import clayImg from '../assets/projects/contrast/contrast-clay-img.webp';
import middleImg from '../assets/projects/contrast/contrast-middle-img.webp';

const Contrast = () => {
  return (
    <ProjectLayout
      title="Contrast Security"
      description={[
        'Working directly with Contrast Security to produce a video featuring senior leadership discussing their cutting-edge security solutions.',
        'Developed and animated 3D glass Möbius strip, created MOGRTs and constructed video from raw footage.',
      ]}
      credits={['3D Design', 'Animation', 'MOGRTs']}
    >
      <div className="pm-video">
        <video controls playsInline preload="metadata">
          <source src="/videos/contrast-security.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="pm-row">
        <img src={normalImg} alt="Normal View" />
        <img src={clayImg} alt="Clay Render" />
      </div>

      <img className="pm-full" src={middleImg} alt="Middle Section" />
    </ProjectLayout>
  );
};

export default Contrast;
